import { COLORS, borderRadiusSm } from 'assets/styled';
import { respondTo } from 'assets/styled/breakpoints';
import styled from 'styled-components';
import { css } from 'styled-components';

export const MODEL_CARD_CONTAINER_HEIGHT = 285;
export const MODEL_CARD_CONTAINER_WIDTH = 300;

interface StyledProps {
  opacityIndex: number;
  opacityCoefficient: number;
  imageLoaded: boolean;
}

export const Container = styled.div`
  border: 1px solid ${COLORS.BORDER};
  border-radius: ${borderRadiusSm};
  width: ${MODEL_CARD_CONTAINER_WIDTH}rem;
  height: ${MODEL_CARD_CONTAINER_HEIGHT}rem;
  position: relative;
  display: flex;
  flex-direction: column;
  ${(props: StyledProps) =>
    props.opacityIndex !== undefined &&
    css`
      opacity: ${1 - (props.opacityIndex * props.opacityCoefficient + 0.2)};
    `}

  ${respondTo.smallLaptop`
    max-width: 300rem;
    width: 100%;
    height: 315rem;
  `}

  ${respondTo.horizontalTablet`
    max-width: 100%;
  `}

  ${respondTo.bigPhone`
    max-width: 100%;
    height: auto;
    margin-bottom: 20rem;
  `}
`;

export const imageStyle = css`
  ${(props: StyledProps) =>
    props.imageLoaded
      ? css`
          min-height: 170rem;
          max-height: 170rem;
          max-width: 100%;
          object-fit: contain;
          border-radius: ${borderRadiusSm};
          ${respondTo.smallLaptop`
            min-height: 200rem;
            max-height: 200rem;
          `}
        `
      : css`
          width: 0;
          height: 0;
          opacity: 0;
        `};
`;

export const NameLabel = styled.label`
  font-weight: 400;
  font-size: 20rem;
  line-height: 32rem;
  color: ${COLORS.BLACK};
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${respondTo.smallLaptop`
    line-height: 28rem;
  `}

  ${respondTo.bigTablet`
    font-size: 18rem;
  `}
`;

export const RowCenter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8rem;
  padding: 0 10rem;
  margin-top: 5rem;
`;

export const AbsoluteCircleWrapper = styled.label`
  z-index: 1;
  position: absolute;
  display: flex;
  left: 0rem;
  top: 0rem;
  background-color: ${COLORS.GREEN_DISABLED};
  border-bottom-right-radius: ${borderRadiusSm};
  border-top-left-radius: ${borderRadiusSm};
  padding-left: 5rem;
  padding-right: 5rem;
`;

export const ModelIdLabel = styled.label`
  color: ${COLORS.STRICT_BLACK};
  margin-left: 3rem;
  margin-right: 3rem;
`;

export const favoriteIconStyle = css`
  z-index: 1;

  &:hover {
    transform: scale(1.2);
    transition: transform ease-in-out 0.1s;

    ${respondTo.bigTablet`
      transition: none;
      transform: none;
    `}
  }
`;

export const RowSection = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  gap: 10rem;
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  padding-bottom: 10rem;
`;

export const CategoryLabel = styled.label`
  font-size: 16rem;
  font-weight: 400;
  color: ${COLORS.BLACK};
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Reference = styled.label`
  font-size: 16rem;
  font-weight: 400;
  color: ${COLORS.GREEN};
  display: block;
`;

export const FavoriteWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  height: 100%;
`;
